import isAndroid from "src/hooks/utils/androidCheck";
import styles from "../assets/styles/main/androidSmartBanner.module.scss";
import { useEffect, useState } from "react";
import { ReactComponent as ImediL } from "../assets/static/images/ImedilL.svg";
import { ReactComponent as XClose } from "src/assets/static/images/x-close-android-smart-banner.svg";
import useFormatById from "src/hooks/utils/useFormatById";

const AndroidSmartBanner = () => {
  const f = useFormatById();

  const [isModalVisible, setIsModalVisible] = useState(false);

  useEffect(() => {
    const lastClosedDate = localStorage.getItem("modalLastClosedDate");
    const today = new Date().toISOString().split("T")[0];

    if (lastClosedDate !== today) {
      setIsModalVisible(true);
    }
  }, []);

  const handleCloseModal = () => {
    const today = new Date().toISOString().split("T")[0];
    localStorage.setItem("modalLastClosedDate", today);
    setIsModalVisible(false);
  };

  return (
    <>
      {isAndroid() && isModalVisible ? (
        <div className={styles.card}>
          <XClose
            className={styles.closeBtn}
            onClick={() => handleCloseModal()}
          />
          <ImediL className={styles.logo} />

          <div className={styles.textWrapper}>
            <div className={styles.title}>Imedi L</div>
            <div>{f("profileMain.getItOnAppStore")}</div>
          </div>

          <a
            href="http://onelink.to/imedil?fbclid=IwZXh0bgNhZW0CMTAAAR0pHj4cvriO-yYPXE2oQIPmx6VnIlFd4ljyaWO9tFxA5JD8tyUvqZHmy50_aem_EMCtWknaxwAxcCvYPZ93Bw"
            target="_blank"
            onClick={() => handleCloseModal()}
          >
            GET
          </a>
        </div>
      ) : null}
    </>
  );
};

export default AndroidSmartBanner;
